import React from 'react';

export default () => (
    <svg viewBox="0 0 100 100">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h86v86H0z" />
            <g transform="translate(3 5)">
                <path fill="#F2ECFE" d="M31 33h49v17H31z" />
                <circle fill="#FBF2C1" cx="12" cy="68" r="8" />
                <g
                    stroke="#2A4473"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                >
                    <path d="M17.875 8.938A8.938 8.938 0 1 1 0 8.938a8.938 8.938 0 1 1 17.875 0zM76.638 0H26.203c-.821 0-1.487.663-1.487 1.482v14.912c0 .819.666 1.482 1.487 1.482h5.547V23l5.424-5.125h39.464c.82 0 1.487-.663 1.487-1.48V1.482C78.125.663 77.459 0 76.638 0zM17.875 36.438a8.938 8.938 0 1 1-17.875 0 8.938 8.938 0 1 1 17.875 0zM76.638 27.5H26.203c-.821 0-1.487.663-1.487 1.482v14.913c0 .817.666 1.48 1.487 1.48h5.547v5.126l5.424-5.125h39.464c.82 0 1.487-.663 1.487-1.481V28.98c0-.818-.666-1.48-1.487-1.48zM17.875 63.938a8.938 8.938 0 1 1-17.875 0 8.938 8.938 0 1 1 17.875 0zM76.638 55H26.203c-.821 0-1.487.663-1.487 1.481v14.913c0 .819.666 1.481 1.487 1.481h5.547v5.126l5.424-5.126h39.464c.82 0 1.487-.662 1.487-1.48V56.481c0-.819-.666-1.481-1.487-1.481z" />
                </g>
            </g>
        </g>
    </svg>
);
